import usePrivateAxios from '@/common/api/usePrivateAxios'
import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'

type UseDeleteGovernmentAllocationProductCategoryDistributionProps = {
  onSuccess: () => void
  onError: (error: AxiosError) => void
}

export const useDeleteGovernmentAllocationProductCategoryDistribution = ({
  onSuccess,
  onError,
}: UseDeleteGovernmentAllocationProductCategoryDistributionProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['deleteGovernmentAllocationProductCategoryDistribution'],
    mutationFn: async (productCategoryDistributionId?: string) => {
      return privateAxios.put(
        `/billing/government_allocation_product_category_distributions/${productCategoryDistributionId}/stale`,
      )
    },
    onSuccess,
    onError,
  })
}
